import { Injectable, inject, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import * as PupilSelectors from './pupil.selectors';
import {
  CoursesForm,
  ProfileForm,
  Pupil,
  PupilAddress,
} from '@lyceo/homi/pupils/util-models';
import {
  PupilCoursesDialogActions,
  PupilDetailsInformationActions,
  PupilDetailsMenuBarActions,
  PupilInformationPageActions,
  PupilProfileDialogActions,
} from './pupil.actions';
import { Observable } from 'rxjs';
import { CallState } from '@lyceo/shared/util-loading';

@Injectable({
  providedIn: 'root',
})
export class PupilFacade {
  private readonly store: Store = inject(Store);

  public readonly allPupils: Signal<Pupil[]> = this.store.selectSignal(
    PupilSelectors.selectAllPupils,
  );

  public readonly paramPupil: Signal<Pupil | undefined> =
    this.store.selectSignal(PupilSelectors.selectParamPupil);

  public readonly paramPupilId: Signal<string | undefined> =
    this.store.selectSignal(PupilSelectors.selectParamPupilId);

  public readonly paramPupilAddress: Signal<PupilAddress | undefined> =
    this.store.selectSignal(PupilSelectors.selectParamPupilAddress);

  public readonly paramPupilLoaded: Signal<boolean> = this.store.selectSignal(
    PupilSelectors.selectParamPupilLoaded,
  );

  public readonly paramPupilLoading: Signal<boolean> = this.store.selectSignal(
    PupilSelectors.selectParamPupilLoading,
  );

  public profileCallState: Observable<CallState> = this.store.select(
    PupilSelectors.selectProfileCallState,
  );
  public coursesCallState: Observable<CallState> = this.store.select(
    PupilSelectors.selectCoursesCallState,
  );

  public pupilDetailsMenuBarInit(): void {
    this.store.dispatch(PupilDetailsMenuBarActions.init());
  }

  public pupilInformationPageInit(): void {
    this.store.dispatch(PupilInformationPageActions.init());
  }

  public pupilDetailsInformationEditProfileClicked(): void {
    this.store.dispatch(PupilDetailsInformationActions.editProfileClicked());
  }

  public pupilDetailsInformationSubmitProfile(profile: ProfileForm): void {
    this.store.dispatch(PupilProfileDialogActions.submitProfile({ profile }));
  }

  public pupilDetailsInformationEditContactClicked(): void {
    this.store.dispatch(PupilDetailsInformationActions.editContactClicked());
  }

  public pupilDetailsInformationEditSchoolClicked(): void {
    this.store.dispatch(PupilDetailsInformationActions.editSchoolClicked());
  }

  public pupilDetailsInformationEditCoursesClicked(): void {
    this.store.dispatch(PupilDetailsInformationActions.editCoursesClicked());
  }

  public pupilDetailsInformationSubmitCourses(courses: CoursesForm): void {
    this.store.dispatch(PupilCoursesDialogActions.submitCourses({ courses }));
  }
}
